import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import useScrollRefresh from "./CustomHooks/useScrollRefresh";
import Topbar from "./Components/Topbar/Topbar";
import HeroCarousel from "./Components/HeroCarousel/HeroCarousel";
import Impact from "./Components/Impact/Impact";
import About from "./Components/About/About";
import VisionMission from "./Components/VisionMission/VisionMission";
import Footer from "./Components/Footer/Footer";
import WhyPuducherry from "./Components/WhyPuducherry/WhyPuducherry";
import Faq from "./Components/Faq/Faq";
import Contact from "./Components/Contact/Contact";
// Parked with the landing-page sections below.
// import Events from "./Components/Events/Events";
// import News from "./Components/News/News";
import Gallery from "./Components/Gallery/Gallery";
import LjkParty from "./Components/LjkParty/LjkParty";
import EventsPage from "./Components/EventsPage/EventsPage";
import NewsPage from "./Components/NewsPage/NewsPage";
import GalleryPage from "./Components/GalleryPage/GalleryPage";

function App() {
  const location = useLocation();
  // Recompute ScrollTrigger positions when the route (and so the page height)
  // changes, otherwise reveals on the next page fire at stale scroll offsets.
  useScrollRefresh(location.pathname);

  return (
    // <div>
    //   <Topbar />
    //   <HeroCarousel />
    //   <About />
    //   <Impact />
    //   <VisionMission />
    //   <WhyPuducherry />
    //   {/* <Faq /> */}
    //   <Footer />
      
    //     <Routes>
    //       <Route path="/contact-us" element={<Contact />} />
    //     </Routes>
     
    // </div>
        <>
      {/* Always visible */}
      <Topbar />

      {/* Define page routes */}
      <Routes>
        {/* Landing Page */}

        
       <Route
  path="/"
  element={
    <>
      <div id="home">
        <HeroCarousel />
      </div>

      <div id="about">
        <About />
      </div>

      <div id="impact">
        <Impact />
      </div>

      <div id="why-puducherry">
        <WhyPuducherry />
      </div>

      <div id="vision-mission">
        <VisionMission />
      </div>

      <LjkParty />

      {/* Events and News are parked for now. The /all-events and /all-news
          routes below are still live, and the footer still links to them, so
          the listings remain reachable - only the landing-page strips are off.
          Uncomment these two lines to bring them back. */}
      {/* <Events /> */}
      {/* <News /> */}
      <Gallery />
    </>
  }
/>

        {/* Contact Page */}
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/all-events" element={<EventsPage />} />
        <Route path="/all-news" element={<NewsPage />} />
        <Route path="/all-album" element={<GalleryPage />} />
      </Routes>

      {/* Always visible */}
      <Footer />
    </>
  );
}

export default App;
